<!-- Table Shared-->
<table mat-table [dataSource]="dataSource" [attr.aria-label]="ariaLabel">
  @for (tableData of objectKeys(columnHeader); track tableData; let i = $index) {
    <ng-container [matColumnDef]="tableData">
      <th mat-header-cell *matHeaderCellDef [attr.aria-label]="columnHeader[tableData]"> {{columnHeader[tableData]}}</th>
      <td mat-cell *matCellDef="let element"[attr.aria-label]="element ? element[tableData].url : element[tableData]">
        @if (element[tableData].url) {
          <a target="_blank" href={{element[tableData].url}} style="text-decoration: none; color: inherit">
            {{element[tableData].url}}
            @if (theme !=='dark-theme') {
              <mat-icon svgIcon='{{element[tableData].icon}}' style="width: 18px; height: 18px;"></mat-icon>
            }@else {
              <mat-icon class="iconDarkTheme" svgIcon='{{element[tableData].icon}}' style="width: 18px; height: 18px;"></mat-icon>
            }
          </a>
        }
        @if (!(element[tableData].url)) {
          {{element[tableData]}}
        }
      </td>
    </ng-container>
  }

  <tr mat-header-row *matHeaderRowDef="objectKeys(columnHeader)"></tr>
  <tr mat-row *matRowDef="let row; columns: objectKeys(columnHeader)"></tr>
</table>
